import React, { useState } from "react";
import { Form } from 'reactstrap';
import { OneRosterCombinedTeamFlowSyncType, combinedTeamFlowSyncTypes } from "../../../../../../models/CoreOneRosterConfigurationCombinedTeam";
import EnumInput from "../../../../../misc/EnumInput";
import ModalComponent from "../../../../../misc/ModalComponent";
import OneRosterCombineTeamActivitiesNew from "./OneRosterCombineTeamActivitiesNew";
import OneRosterCombineTeamGroupsNew from "./OneRosterCombineTeamGroupsNew";
import { useTranslation } from 'react-i18next';


interface OneRosterCombineTeamCreateNewProps {
    isOpen: boolean
    toggleModal: () => void
    success: (success: boolean) => void
    disabled: boolean
}

const OneRosterCombineTeamCreateNew: React.FC<OneRosterCombineTeamCreateNewProps> = (props) => {
    const [type, setType] = useState<OneRosterCombinedTeamFlowSyncType>(OneRosterCombinedTeamFlowSyncType.Undefined);
    const [confirmed, setConfirmed] = useState<boolean>(false);

    const { t } = useTranslation(['configuration', 'common']);

    const close = () => {
        setType(OneRosterCombinedTeamFlowSyncType.Undefined);
        setConfirmed(false)
        props.toggleModal()
    };

    const renderModal = () => {
        switch (type) {
            case OneRosterCombinedTeamFlowSyncType.Group:
                return (
                    <OneRosterCombineTeamGroupsNew
                        isOpen={props.isOpen}
                        toggleModal={close}
                        success={props.success}
                        disabled={props.disabled}
                    />
                );
            case OneRosterCombinedTeamFlowSyncType.Activity:
                return (
                    <OneRosterCombineTeamActivitiesNew
                        isOpen={props.isOpen}
                        toggleModal={close}
                        success={props.success}
                        disabled={props.disabled}
                    />
                );
            default: return;
        }
    };

    return (<>
        <ModalComponent
            isOpen={props.isOpen}
            toggleModal={() => close()}
            header={t('oneRosterConfiguration.combineTeam.title', { ns: 'configuration' })}
            update={() => setConfirmed(true)}
            disabled={type === OneRosterCombinedTeamFlowSyncType.Undefined || props.disabled}
            confirm={t('action.ok', { ns: 'common' })}
            cancel={t('action.cancel', { ns: 'common' })}
        >

            <Form>
                <EnumInput
                    title={t('oneRosterConfiguration.combineTeam.table.type', { ns: 'configuration' })}
                    name='combinedTeamFlowSyncType'
                    value={type}
                    options={combinedTeamFlowSyncTypes.map(key => ({
                        value: key,
                        text: t(`oneRosterConfiguration.combineTeam.flowSyncType.${key}`, { ns: 'configuration' })
                    }))}
                    onChange={(_, value) => setType(value)}
                    titleSmall={true}
                />
            </Form>

        </ModalComponent>

        {confirmed && renderModal()}
    </>);
}

export default OneRosterCombineTeamCreateNew;
